module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nutrient-Rich Kale Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 2 | Prep Time: 5 minutes | Cook Time: N/A")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("Kale is one of those superfoods you always hear so much about. The trick is figuring out how to incorporate it into your meals. I love this smoothie recipe since you can barely even taste the kale with all the yummy fruits inside.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 cups fresh or frozen kale")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ large banana, sliced and frozen")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup frozen blueberries or mixed berries")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup frozen pineapple chunks")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 cup filtered water")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2/3 cup 100 percent pomegranate juice")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("Juice of ½ lime")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. Place the kale, banana, blueberries, pineapple chunks, filtered water, pomegranate juice, and lime juice in a blender.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. Blend until smooth. Pour into glasses and serve.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09768f74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect9.vue
// module id = 111
// module chunks = 0